import Helper from './Helper';

class Home {
  constructor() {
    this.controls = Array.prototype.slice.call(document.querySelectorAll('.ns-anchor-container__controls'));

    let length = this.controls.length;
    let i = 1;
    this.controls.forEach(control => {
      const current = control.querySelector('.ns-anchor-container__current');
      const max = control.querySelector('.ns-anchor-container__max');

      current.innerText = i;
      max.innerText = length;
      control.dataset.iterator = i;
      this.mapButtons(control, i);
      i++;
    });
  }

  mapButtons(control, i){
    const buttonNext = control.querySelector('.ns-anchor-container__button--next');
    const buttonPrev = control.querySelector('.ns-anchor-container__button--prev');
    buttonNext.addEventListener('click', e => {
      const scrollToEl = document.querySelector('[data-iterator="'+(i+1)+'"]');
      if(!!scrollToEl){
        this.scrollTo(scrollToEl);
      }
    });
    buttonPrev.addEventListener('click', e => {
      const scrollToEl = document.querySelector('[data-iterator="'+(i-1)+'"]');
      if(!!scrollToEl){
        this.scrollTo(scrollToEl);
      } else{
        this.scrollTo(document.querySelector('header'));
      }
    });
  }

  scrollTo(el){
    if(el){
      window.scrollTo({
        top: Helper.getRealOffsetTop(el) - 20,
        left: 0,
        behavior: 'smooth'
      });
      
    }
}

}

export default Home;
